export default "__VITE_ASSET__BYNz5MSe__"